import get from 'lodash/get';
import Highlighter from 'react-highlight-words';
import handleEvent from 'utils/handleEvent';

const getContent = ({
  focusedOption,
  onFocusOption,
  inputValue,
  loading,
  msg,
  noResultsText,
  options,
  onSelectValue,
  onUnfocusOption,
}) => {
  if ((!options || !options.length) && !loading) {
    return <div className='Select-noresults'>{noResultsText}</div>;
  }
  const handleClick = (option) => handleEvent(() => onSelectValue(option));
  const handleMouseEnter = (option) => handleEvent(() => onFocusOption(option));
  return (
    <table className='table-striped table'>
      <thead>
        <tr>
          <th>
            {get(msg, ['configurations', 'roleAssignments', 'menuTitle'])}
          </th>
        </tr>
      </thead>
      <tbody onMouseLeave={onUnfocusOption}>
        {options.map((option) => (
          <tr
            key={option.value}
            onClick={handleClick(option)}
            onMouseEnter={handleMouseEnter(option)}
            className={`select-menu-renderer ${
              focusedOption && focusedOption.value === option.value
                ? 'select-menu-focused'
                : ''
            }`}
          >
            <td>
              <Highlighter
                highlightClassName='menu-highlight'
                searchWords={[inputValue]}
                autoEscape
                textToHighlight={option.label ?? ''}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const groupMenuRenderer =
  (msg, loading, noResultsText, inputValue) =>
  ({
    options,
    focusedOption,
    onSelectValue,
    onFocusOption,
    onUnfocusOption,
  }) => {
    return (
      <div className='Select-menu-outer'>
        <div className='Select-menu'>
          {getContent({
            focusedOption,
            onFocusOption,
            inputValue,
            loading,
            msg,
            noResultsText,
            options,
            onSelectValue,
            onUnfocusOption,
          })}
        </div>
      </div>
    );
  };

export default groupMenuRenderer;
